export default {
  apiUrl: window.g.apiUrl,
  tokenKey: window.g.tokenKey,
  version: window.g.tokenKey
}
